import serverUrl from "../config/serverUrl"

export async function graphqlRequest({
  query,
  variables = {},
  authToken,
  endpoint = `${serverUrl}/graphql`,
  fallbackErrorMessage = "Unable to complete request.",
}) {
  if (!query) {
    throw new Error("GraphQL query is required")
  }

  const headers = {
    "Content-Type": "application/json",
  }

  if (authToken) {
    headers.Authorization = authToken
  }

  const response = await fetch(endpoint, {
    method: "POST",
    headers,
    body: JSON.stringify({
      query,
      variables,
    }),
  })

  if (!response.ok) {
    throw new Error(fallbackErrorMessage)
  }

  const result = await response.json()
  const graphQLErrors = result?.errors

  if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) {
    const graphQLErrorMessage = graphQLErrors
      .map((errorItem) => errorItem?.message)
      .filter(Boolean)
      .join("; ")

    throw new Error(graphQLErrorMessage || fallbackErrorMessage)
  }

  return result?.data
}

export default graphqlRequest